export default __webpack_public_path__ + "static/media/element_23.cbdee895.webp";